import { message } from "antd";
import { post } from "../../utils/backend";
import { useLongfansMock } from "../../global/GlobalMock";
import {
  mockSendCreatorApplyVerificationCode,
  mockSubmitCreatorApply,
} from "./CreatorApplyMock";
import type { CreatorApplyPayload, CreatorApplyResult } from "./CreatorApplyType";

const mock = useLongfansMock;

const sendApplyVerificationCode = async (phoneNo: string): Promise<boolean> => {
  if (mock) {
    return mockSendCreatorApplyVerificationCode(phoneNo);
  }
  const res = await post<{ phoneNo: string }, boolean>(
    "/api/creator/sendApplyVerificationCode",
    { phoneNo },
    { silent: true }
  );
  if (typeof res === "string") {
    if (res === "1006") {
      message.error("发送过于频繁，请稍后再试");
    }
    return false;
  }
  return !!res;
};

const submitApply = async (
  payload: CreatorApplyPayload
): Promise<CreatorApplyResult | null> => {
  if (mock) {
    return mockSubmitCreatorApply(payload);
  }
  const res = await post<CreatorApplyPayload, CreatorApplyResult>(
    "/api/creator/submitApply",
    payload
  );
  if (typeof res === "string" || !res?.success) {
    return null;
  }
  return res;
};

export const CreatorApplyApi = {
  sendApplyVerificationCode,
  submitApply,
};
